import { useTheme, useMediaQuery, Button, IconButton, Input, Typography, Card, CardContent } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { API_URL } from './tools/consts';

export default function HomePage() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [pseudo, setPseudo] = useState('');
    const navigate = useNavigate();

    const handleNavigate = () => {
        if (pseudo.trim() && pseudo.length > 0) {
            if (pseudo.length < 30) {
                if (pseudo.toLowerCase() == "raz") {
                    deleteAllPlayers();
                }

                else if(pseudo.toLowerCase() == "animation") {
                    navigate('/animation');
                }

                else if (pseudo.toLowerCase() != "raz") {
                    navigate('/jeu', { state: { pseudo } });
                }
            }
            else {
                alert("Ton pseudo est trop long");
            }
        } else {
            console.log(isMobile);
            alert("Tu dois entrer un pseudo pour jouer.");
        }
    };

    const deleteAllPlayers = async () => {
        const qr = await fetch(API_URL + "players/delete_all", {
            method: "POST",
        });
        setPseudo('');
    };

    const handleEnter = (event) => {
        if (event.key === 'Enter') {
            handleNavigate();
        }

    }

    return (
        <>
        <div
            style={{
                backgroundImage: `url('/Couverture.jpg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                position: 'relative',
                
            }}
        >
      
            <img src='/logo_o.png' alt='' style={{  width: isMobile ? '60vw' : '30vw', textAlign: 'center', position: 'absolute', top: '50px' }} />

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: '13em',
                flexDirection: 'column',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Plus opaque pour la lisibilité
                padding: '20px',
                borderRadius: '10px', // Bordures arrondies
            }}>
                <Typography
                    variant="h6"
                    sx={{
                        color: '#000000',
                        fontWeight: '500',
                    }}
                >
                    Rentre ton pseudo pour débuter
                </Typography>
                <Input
                    placeholder="Pseudo"
                    value={pseudo}
                    color="success"
                    onChange={(e) => setPseudo(e.target.value)}
                    onKeyDown={handleEnter}
                    style={{
                        marginBottom: '20px',
                        padding: '5px',
                        backgroundColor: 'white',
                        border: '2px solid #e0e0e0', // Bordure pour le champ de saisie
                        borderRadius: '5px', // Bordures arrondies pour le champ
                    }}
                />
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleNavigate}
                    style={{
                        borderRadius: '5px', // Bordures arrondies pour le bouton
                    }}
                >
                    Démarrer la partie
                </Button>
            </div>
            <div style={{ backgroundColor: 'white', borderRadius: '10px', margin: '10px', padding: '10px', position: 'absolute', bottom: '10px' }}>
            </div>
        </div>
        </>
    );
}